import { emptyFieldHolder } from 'components/molecules/CardList';
import React from 'react';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { formatDate } from 'utils/date';
import { colors } from 'theme/colors';
import { Chips } from 'components/atoms/Chips';
import { StyledRouterLink } from 'components/atoms/RouterLink/styles';
import { ERouteLinks } from 'models/route';
import { useGlobalProperty } from 'models/globalPropertyContext';
import { licencePrintStatusVariant } from 'pages/LicencesPage/helpers';

interface IPrintoutHistoryTableCardProps {
  data: any;
  t: (key: string) => string;
}

const PrintoutHistoryTableCard = ({ data, t }: IPrintoutHistoryTableCardProps) => {
  const { longDateFormat } = useGlobalProperty();

  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        px: 2,
      }}
      columnSpacing={2}
    >
      <Grid size={{ xs: 12, sm: 6 }} sx={{ py: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntity.licenceDetails.printoutHistory.dateTime.column')}
        </Typography>
        <Typography variant="body2">
          {data.eventDate ? formatDate(data.eventDate, longDateFormat) : ''}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ py: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntity.licenceDetails.printoutHistory.requestStatus.column')}
        </Typography>
        <Typography variant="body2">
          <Chips
            text={data.status}
            variant={licencePrintStatusVariant(data.statusUniqueId)}
            fullWidth
          />
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ py: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntity.licenceDetails.printoutHistory.type.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.type)}</Typography>
      </Grid>
      <Grid size={{ xs: 12 }} sx={{ py: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntity.licenceDetails.printoutHistory.description.column')}
        </Typography>
        <Typography
          variant="body2"
          component="div"
          sx={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}
        >
          {data.description}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ py: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntity.licenceDetails.printoutHistory.userId.column')}
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
          {emptyFieldHolder(data.userId)}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ py: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntity.licenceDetails.printoutHistory.user.column')}
        </Typography>
        <Typography variant="body2" component="div" sx={{ wordBreak: 'break-word' }}>
          {data.userUniqueId ? (
            <StyledRouterLink to={ERouteLinks.ViewUser.replace(':id', data.userUniqueId)}>
              {data.user}
            </StyledRouterLink>
          ) : (
            emptyFieldHolder(data.user)
          )}
        </Typography>
      </Grid>
    </Grid>
  );
};

export { PrintoutHistoryTableCard };
